<script>
  import { collectionProducts, isLoading } from "./stores/collection-products-store.js";
  import { filterMenu } from './stores/filter-store.js';
  import ProductCard from "./ProductCard.svelte";
  import GhostCard from './GhostCard.svelte';
</script>

<ul class={`h-fit w-full grid grid-cols-2 ${$filterMenu ? 'lg:grid-cols-3' : 'lg:grid-cols-4'} gap-x-xxs-mobile lg:gap-x-m gap-y-xl-mobile lg:gap-y-2xl mt-xl-mobile lg:mt-2xl`}>
  {#each $collectionProducts as product (product.id)}
    <li>
      <ProductCard {product} />
    </li>
  {/each}

  {#if $isLoading}
    <GhostCard />
    <GhostCard />
    <GhostCard />
    <GhostCard />
    <GhostCard />
    <GhostCard />
  {/if}
</ul>
